import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Col } from './ui/Grid';
import Text from './ui/Text';

function Detail(props) {
  const { data } = props;
  return (
    <div className="margin-space">
      {data.h2 && (
        <li>
          <h2>{data.h2}</h2>
        </li>
      )}
      {data.list &&
        data.list.map((item, i) => (
          <Grid cols="8" mcols="3" key={`detail-${i}`}>
            <Col span="1">{item.year}</Col>
            <Col span="7" mspan="2">
              {item.text}
            </Col>
          </Grid>
        ))}
      {data.text && <Text dark text={data.text} />}
    </div>
  );
}
Detail.defaultProps = {};
Detail.propTypes = {
  data: PropTypes.shape({}).isRequired
};

export default Detail;



// WEBPACK FOOTER //
// ./src/components/Detail.jsx